import { render, staticRenderFns } from "./PieIcon.vue?vue&type=template&id=10975c10&scoped=true"
import script from "./PieIcon.vue?vue&type=script&lang=js"
export * from "./PieIcon.vue?vue&type=script&lang=js"
import style0 from "./PieIcon.vue?vue&type=style&index=0&id=10975c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10975c10",
  null
  
)

export default component.exports